<div class="container my-5 px-5 pt-5 pb-4 z-depth-1">
  <div class="row d-flex justify-content-center">
    <!--Grid column-->
    <div class="col-md-6 text-center">
      <!-- <h2 class="font-weight-bold text-success"></h2> -->

      <!-- <p class="text-muted">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id quam sapiente
          molestiae.</p> -->
    </div>
    <!--Grid column-->
  </div>
  <!--Grid row-->

  <!--Section: Content-->
  <section class="dark-grey-text">
    <style>
      .d-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: 100px;
        grid-gap: 7px;
      }

      .item {
        position: relative;
      }

      .item:nth-child(1) {
        grid-column: 1 / 2;
        grid-row: 1 / 4;
      }

      .item:nth-child(2) {
        grid-column: 2;
        grid-row: 0 / 3;
      }

      .item:nth-child(3) {
        grid-column: 2;
        grid-row: 2 / 3;
      }

      .item:nth-child(4) {
        grid-column: 2;
        grid-row: 3 / 3;
      }

      .item a {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        overflow: hidden;
      }

      .item img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    </style>

    <div class="row align-items-center">
      <div class="col-lg-6 mb-4">
        <h2 class="font-weight-normal font-weight-bold mb-4 text-success">
          Raghunathpur Panchayat
        </h2>
        <!-- <p class="lead text-muted">Beautifully designed by best interior designers for the best web designers</p> -->
        <p class="font-weight-normal">
          Raghunathpur GP under Sadar Block is 18 KM from Block Headquarter. The
          GP is established in 1954. Total 16 Nos. of Village in the GP divided
          in to 15 wards. Total population of the GP is 7122 consisting 3598
          male 3524 female. It is a important place of education and health
          facilities. The area of the GP is 283 Hector .GP is famous for
          Kanjhari Dam, Dhadi part Picnic Sport,Ghadagharti Picnic Sport,
          Nischitapur Picnic Sport, Raghunathpur forest Picnic Sport, Makara
          Festival Chaka, Dumuria, Dantha, Kirtan and lord Raghunatheswar Shiv
          Mandir. Most of the people depend on agriculture is the main
          profession of the village people. The Total house hold of the GP is
          1627.
        </p>
        <a
          href="../../assets/RAGHUNATHPUR G.P. PF.pptx"
          class="btn btn-outline-success float-right"
        >
          Know More..
        </a>
      </div>

      <div class="col-lg-6 mb-4">
        <div id="mdb-lightbox-ui"></div>

        <div class="d-grid mdb-lightbox">
          <figure class="item">
            <a
              href="../../assets/WhatsApp Image 2025-09-10 at 10.25.31 PM.jpeg"
              class="z-depth-1 rounded"
              data-size="1600x1067"
            >
              <img
                src="../../assets/WhatsApp Image 2025-09-10 at 10.25.31 PM.jpeg"
              />
            </a>
          </figure>
          <figure class="item">
            <a
              href="../../assets/WhatsApp Image 2025-09-10 at 10.25.38 PM.jpeg"
              class="z-depth-1 rounded"
              data-size="1600x1067"
            >
              <img
                src="../../assets/WhatsApp Image 2025-09-10 at 10.25.38 PM.jpeg"
              />
            </a>
          </figure>
          <figure class="item">
            <a
              href="../../assets/WhatsApp Image 2025-09-10 at 10.25.39 PM (1).jpeg"
              class="z-depth-1 rounded"
              data-size="1600x1067"
            >
              <img
                src="../../assets/WhatsApp Image 2025-09-10 at 10.25.39 PM (1).jpeg"
              />
            </a>
          </figure>
          <figure class="item">
            <a
              href="../../assets/WhatsApp Image 2025-09-10 at 10.25.39 PM.jpeg"
              class="z-depth-1 rounded"
              data-size="1600x1067"
            >
              <img
                src="../../assets/WhatsApp Image 2025-09-10 at 10.25.39 PM.jpeg"
              />
            </a>
          </figure>
        </div>
      </div>
    </div>
  </section>

  <!--Section: Content-->
</div>
